import { useAuthContext } from '../../../../context/auth.context'
import { useRoleSysAlertRouting } from '../../../../role/hook/role-sys'

export const READ_ONLY_ROLE = "You can view alert routing but not change it. Changing routes and targets needs the alert routing update permission."
export const READ_ONLY_IMPERSONATING = "You're signed in as someone else, so alert routing can be viewed but not changed. End the impersonation to make changes."

// Who may change alert routing (spec §15, §19): SYS_ALERT_ROUTING update,
// and never from an impersonated session (the server answers 403
// alert_routing.not_while_impersonating). The UI offers no write it can't do.
export const useAlertRoutingAccess = () => {
  const { state } = useAuthContext()
  const role = useRoleSysAlertRouting()
  const impersonating = Boolean(state && state.jwtClaims && state.jwtClaims.impersonationEndsAt)
  const canEdit = Boolean(role.accessUpdate) && !impersonating
  const reason = canEdit ? null : impersonating ? READ_ONLY_IMPERSONATING : READ_ONLY_ROLE
  return { canEdit, impersonating, reason }
}
